/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @11-09-2019 20:58:43
*/


const planDetailsReducer = (state = {"devices":[],"basePlan":{},"serviceName":"","isGlobalLoading":false,"isConfirmationReached":false,"isSummaryReached":false,"services": {}, "customize": { "addons": [],"devices":[], "serviceOptions": {} }, "customerInfo": {"updateCustomerDetails":{},"identityDetails":[]}, "billingInfo": {}, "installation": {},"confirmation":{},"changePlanResponse":{}, "givenAddress": {}, "generalResponse":{"allTaxDetails":{},"stateList":[],"compatibleDevicesArray" :[],"depositAmount":"","isDepositAmountRequired":false,"compatibleArray":false,"productFamily":[],"isCompatible":false}}, action) => {
	if (action.type === 'SET_PLAN_DETAILS') {
		var newState = {};
		Object.assign(newState, state);
		// newState[action.key] = action.payload;
		insertDataIntoGivenPath(newState,action.key,action.payload);
		console.log("planDetails newState >>", newState);
		return newState;
	} else {
		return state
	}
}

function insertDataIntoGivenPath(obj, props, newValue) {
	var propsArr = props.split('.');
	var prop = propsArr.splice(0, 1);
	var nextObject = obj[prop];
	if (!propsArr.join('.')) {
		return obj[prop] = newValue;
	} else {
		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
		return obj;
	}
}

export default planDetailsReducer;
